import request from '@/utils/request'


export function orderAmountChart(query) {
  return request({
    url: '/biz/admin/statistics/order/order/amount',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

export function orderDayAmount(query) {
  return request({
    url: '/biz/admin/statistics/order/order/day',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}
export function orderCancelChart(query) {
  return request({
    url: '/biz/admin/statistics/order/order/cancel',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

export function orderRefundChart(query) {
  return request({
    url: '/biz/admin/statistics/order/order/refund',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

export function orderTimeChart(query) {
  return request({
    url: '/biz/admin/statistics/order/order/time',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}
export function orderNationChart(query) {
  return request({
    url: '/biz/admin/statistics/order/order/nation',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

export function orderUserCount(query) {
  return request({
    url: '/biz/admin/statistics/order/order/user/count',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}


